import { apiSlice } from "../../app/api/apiSlice";

export const donationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createFuelDonation: builder.mutation({
      query: (body) => ({
        url: "/donations/create-fuel-donation",
        method: "POST",
        body,
      }),

      invalidatesTags: ["Donation"],
    }),

    getDonationStats: builder.query({
      query: () => "/donations/stats",
      providesTags: ["Donation"],
    }),

    getAllDonations: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: "/donations/admin",
        params: { page, limit },
      }),
      providesTags: ["Donation"],
    }),

    getStripeBalance: builder.query({
      query: () => "/donations/balance",
      providesTags: ["Donation"],
    }),

    // Query to fetch public feed items with pagination variables
    getPublicDonations: builder.query({
      query: ({ page = 1, limit = 10 }) =>
        `/donations/public?page=${page}&limit=${limit}`,
      providesTags: ["Donations"],
      // Merges cache results so past items stay on screen when hitting "Load More"
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 1) {
          return newItems;
        }
        currentCache.items.push(...newItems.items);
        currentCache.page = newItems.page;
        currentCache.totalPages = newItems.totalPages;
      },
      forceRefetch: ({ currentArg, previousArg }) => currentArg !== previousArg,
    }),
  }),
});

export const {
  useCreateFuelDonationMutation,
  useGetDonationStatsQuery,
  useGetAllDonationsQuery,
  useGetPublicDonationsQuery,
  useGetStripeBalanceQuery,
} = donationApiSlice;
